var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return (_vm.items && _vm.items.length > 0) || _vm.isSomeAdmin
    ? _c(
        "v-card",
        [
          _c("Subheader", {
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c(
                        "v-toolbar-title",
                        [
                          _c("v-icon", { attrs: { medium: "" } }, [
                            _vm._v("dashboard"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "headline" }, [
                            _vm._v("Associated Content"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _vm.isAuthed && _vm.isSomeAdmin && _vm.isEdit
                        ? _c(
                            "SecondaryBtn",
                            {
                              attrs: {
                                color: "success",
                                light: "",
                                icon: "library_add",
                                disabled: _vm.isReorderingItems,
                                small: "",
                              },
                              on: { click: _vm.onAdd },
                            },
                            [_vm._v("\n        Add\n      ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isAuthed && _vm.isSomeAdmin
                        ? _c(
                            "SecondaryBtn",
                            {
                              attrs: {
                                color: _vm.actionButtonInfo.color,
                                light: "",
                                icon: _vm.actionButtonInfo.icon,
                                small: "",
                                loading: _vm.isReorderingItems,
                              },
                              on: { click: _vm.actionButtonInfo.onClick },
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(_vm.actionButtonInfo.text) +
                                  "\n      "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3490667299
            ),
          }),
          _vm._v(" "),
          _c("StaticContentItemList", {
            attrs: { isEdit: _vm.isEdit, "tenant-name": _vm.tenantName },
          }),
          _vm._v(" "),
          _c("StaticContentFormModal", {
            ref: "form",
            attrs: { "add-form": "", "tenant-name": _vm.tenantName },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }